import { useEffect, useState } from "react";
import axios from "axios";
import Instagram from "./Instagram";
function InstagramFetchUrl() {

  const userId="9878909355499012"
  const accessToken="IGAAc67HCmo01BZAFBTMDVsM3lnamp3aVZAfLVlIX2h6dFFDdmJkbG1wZAzJ1N3IyY3NGTG9MVUhJd0xnLXVlMXJiMjcwZA2p2bWl6aGNYT0N0UDRESE95UzZANXzRKcENuUWZArYnlkUm9vTjdhTjY0d1hiUWJRZAGNzMk9sVnNTRUVPVQZDZD"
  //Fetching data from instaUrl will return a list of id for the media items, which can be used to retrieve the actual media item.
  const instaUrl="https://graph.instagram.com/" + userId+ "/media?access_token=" + accessToken
  const [instaMediaItemIdList, setInstaMediaItemIdList] = useState([]);
  useEffect(() => {
    const fetchInstaMediaItemIdList = async () => {
      try {
        const response = await axios.get(instaUrl);
        setInstaMediaItemIdList(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } 
    };
    fetchInstaMediaItemIdList();
  }, []); // Runs once on component mount
  
  return (
    <Instagram userId={userId} accessToken={accessToken} instaUrl={instaUrl}></Instagram>
  )
}
export default InstagramFetchUrl